import { interfaceHelper, selectObjToString } from '../interface.helper'

import { IUserInterface } from './user.interface'
import { InitialUserDocumentAndExpiration, UserCoreModel } from '../users-core/users-core.model'

import { CONST } from '../../const/const'

export class UserModel extends UserCoreModel {
  public userOrganizationName: IUserInterface['userOrganizationName']
  public userPhoneNumber: IUserInterface['userPhoneNumber']
  public userPhoneCode: IUserInterface['userPhoneCode']
  public userDefaultRole: IUserInterface['userDefaultRole']
  public vendorname: IUserInterface['vendorname']

  public userAlternativeNumber: IUserInterface['userAlternativeNumber']

  public userStripeId: IUserInterface['userStripeId']
  public userStripeDefaultPmId: IUserInterface['userStripeDefaultPmId']
  public userStripeAccountId: IUserInterface['userStripeAccountId']
  public userStripeAccountStatus: IUserInterface['userStripeAccountStatus']
  public userBankConnected: IUserInterface['userBankConnected']
  public userConnectAccountStatusMessage: IUserInterface['userConnectAccountStatusMessage']

  public userSocialSecurityNumber: IUserInterface['userSocialSecurityNumber']

  public userSafeSupportStatus: IUserInterface['userSafeSupportStatus']
  public userSafeSupportExpiry: IUserInterface['userSafeSupportExpiry']

  public userBackgroundCheckStatus: IUserInterface['userBackgroundCheckStatus']
  public userBackgroundCheckExpiry: IUserInterface['userBackgroundCheckExpiry']

  public userJudgingLicense?: IUserInterface['userJudgingLicense']

  public userNotificationsSettings: IUserInterface['userNotificationsSettings']

  public userBusinessName: IUserInterface['userBusinessName']

  public userLegalPolicyName?: IUserInterface['userLegalPolicyName']

  public userBrandImages?: IUserInterface['userBrandImages']
  public userBrandVideos?: IUserInterface['userBrandVideos']
  public userForeignEndorsement: IUserInterface['userForeignEndorsement']

  constructor(obj?: IUserInterface) {
    super(obj)

    this.userOrganizationName = obj?.userOrganizationName ?? ''
    this.userDefaultRole = obj?.userDefaultRole ?? CONST.UI.TEAM_MEMBERS_ROLES.OWNER
    this.userPhoneNumber = obj?.userPhoneNumber ?? ''
    this.userPhoneCode = obj?.userPhoneCode ?? ''
    this.vendorname = obj?.vendorname ?? ''

    this.userAlternativeNumber = obj?.userAlternativeNumber ?? ''

    this.userStripeId = obj?.userStripeId ?? ''
    this.userStripeDefaultPmId = obj?.userStripeDefaultPmId ?? ''
    this.userStripeAccountId = obj?.userStripeAccountId ?? null
    this.userStripeAccountStatus = this.getUserStripeAccountStatus(
      obj?.userStripeAccountStatus
    ) as any

    this.userBankConnected = obj?.userBankConnected ?? false
    this.userConnectAccountStatusMessage = obj?.userConnectAccountStatusMessage ?? null

    this.userSocialSecurityNumber = obj?.userSocialSecurityNumber ?? ''

    this.userSafeSupportStatus = selectObjToString(obj?.userSafeSupportStatus) ?? null
    this.userSafeSupportExpiry = obj?.userSafeSupportExpiry ?? null

    this.userBackgroundCheckStatus = selectObjToString(obj?.userBackgroundCheckStatus) ?? null
    this.userBackgroundCheckExpiry = obj?.userBackgroundCheckExpiry ?? null

    this.userJudgingLicense = selectObjToString(obj?.userJudgingLicense) ?? ''

    this.userNotificationsSettings =
      interfaceHelper.getNotificationSettings(obj?.userNotificationsSettings) ?? null

    this.userBusinessName = obj?.userBusinessName ?? ''

    this.userLegalPolicyName = obj?.userLegalPolicyName ?? ''

    this.userBrandImages = obj?.userBrandImages ?? []
    this.userBrandVideos = obj?.userBrandVideos ?? []
    this.userForeignEndorsement = obj?.userForeignEndorsement ?? InitialUserDocumentAndExpiration
  }

  public getUserStripeAccountStatus(status: any): IUserInterface['userStripeAccountStatus'] {
    let statuses = ['pending', 'connected']
    let status_: IUserInterface['userStripeAccountStatus'] = status ?? null
    if (statuses.includes(status_ as any)) return status_
    else return null
  }

  static fromFirestoreDoc(doc: any) {
    return new UserModel({
      id: doc.id,
      ...doc.data(),
    })
  }
}
